
  import { Component, Prop, Vue} from "vue-property-decorator";
  import CardItemCircle from "@/components/dashboard/cards/CardItemCircle.vue";
  import LIST_DOCUMENTS from "@/apollo/documents/ListDocuments.gql";
  
  @Component({
    components: {
      CardItemCircle,
    }
  })
  export default class CardItemScaffold extends Vue {
    @Prop({type: [String, Number], default: undefined}) readonly itemNumber?: string | number;
    @Prop({type: String, default: undefined}) readonly itemTitle!: string;
    @Prop({type: Boolean, default: false}) readonly flexRow!: boolean;
    @Prop({type: [String, Number], default: undefined}) readonly circleText?: string | number;
    @Prop({type: String, default: undefined}) readonly circleAvatar?: string;
    @Prop({type: Object, default: undefined}) readonly itemLink?: string;
  
    get flexDirection(): string {
      if (!this.flexRow) {
        return "flex-col";
      }
      return "flex-row items-center";
    }
  
    get rowLabelCLass(): string {
      if (this.flexRow) {
        return "w-28";
      }
      return "";
    }
  }
  